import { render, staticRenderFns } from "./DonationReceiptConfigDialog.vue?vue&type=template&id=c412466c&"
import script from "./DonationReceiptConfigDialog.vue?vue&type=script&lang=js&"
export * from "./DonationReceiptConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports